import { Stack, styled, Typography } from '@mui/material'
import Divider from '@mui/material/Divider'

const MainAreaWrapper = styled(Stack)`
  flex-direction: row;
  padding: 16px 24px;
`

const ChartSection = styled(Stack)`
  flex: 3;
`

const StyledDivider = styled(Divider)`
  margin: 0 16px;
`

const CostText = styled(Typography)`
  font-weight: 800;
  font-size: 18px;
  color: black;
`

export { MainAreaWrapper, ChartSection, CostText, StyledDivider }
